import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import {Checkbox} from 'rmwc';

import * as styles from '../../styles';
import {request} from '../../containers/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import {refresh as paginatorRefresh, clearSelection} from '../../paginator/actions';
import examinationsFiltersSelectorGenerator from '../examinations/filters';


export default class ExaminationStoreItems extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {
            field: item => `${item.item_object.title} (${item.item_object.id.persian()})`,
            label: window.gettext('Title'),
        },
        {
            field: item => _.map(item.item_object.grades, grade => grade.title).join(window.gettext(',') + ' '),
            label: window.gettext('Grade'),
        },
        {
            field: item => ({
                1: window.gettext('Restricted'),
                2: window.gettext('Virtual'),
            })[item.category] 
            , label: window.gettext('Category'),
        },
        {field: 'price', label: window.gettext('Price')},
        {
            field: item => item.off ? <span style={{color: 'red'}}>{'%' + item.off.persian()}</span> : null,
            label: window.gettext('Off'),
        },
        {
            field: item => <div
                style={{
                    backgroundColor: item.supply_in_store
                        ? styles.successBackColor
                        : styles.warningBackColor,
                    color: item.supply_in_store
                        ? styles.successColor
                        : styles.warningColor,
                    borderColor: item.supply_in_store
                        ? styles.successBorderColor
                        : styles.warningBorderColor,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '2em',
                }}
                className={item.supply_in_store ? 'fa-check' : 'fa-times'}>
            </div>,
            label: window.gettext('Supply in store'),
        },
        {field: 'sold', label: window.gettext('Sold')},
        {
            field: item => <button
                style={{
                    ...styles.button,
                    backgroundColor: 'transparent',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={async event => {
                    event.stopPropagation();
                    this.context.store.dispatch(push('/store/examination-items-packs/' + item.id + '/'));
                }}
                onMouseUp={({target}) => target.blur()}>
                {window.gettext('Pack Sell')}
            </button>,
            
        },
        {
            field: item => <button
                style={{
                    ...styles.button,
                    backgroundColor: 'transparent',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={async event => {
                    event.stopPropagation();
                    this.context.store.dispatch(push('/store/orders/?item=' + item.id));
                }}
                onMouseUp={({target}) => target.blur()}>
                {window.gettext('Sell Report')}
            </button>,
            
        },
    ]

    examinationsFiltersSelector = examinationsFiltersSelectorGenerator.bind(this)('examination__', {})

    filtersSelector = createSelector.bind(this)(
        [
            () => {
                let categories = this.props.location.query.category || [];
                if (!(categories instanceof Array))
                    categories = [categories];
                return _.map(categories, category => Number.parseInt(category));
            },
            store => this.examinationsFiltersSelector(store),
        ],
        (categories, examinationsFilters) => [
            {
                field: 'type',
                selected: {'examination': null},
            },
            {
                field: 'category',
                label: window.gettext('Category'),
                component: <div>
                    {_.map(
                        Array(2),
                        (__, index) => <div
                            key={index}
                            style={{
                                display: 'block',
                                float: 'right',
                                width: '10em',
                                cursor: 'pointer',
                            }}>
                            <Checkbox
                                checked={_.includes(categories, index + 1)}
                                onChange={this.categoryChanged.bind(
                                    this,
                                    index + 1,
                                )}>
                                {{
                                    1: window.gettext('Restricted'),
                                    2: window.gettext('Virtual'),
                                }[index + 1]}
                            </Checkbox>
                        </div>,
                    )}
                </div>,
                selected: _.mapValues(
                    _.mapKeys(categories, _.identity),
                    category => ({
                        1: window.gettext('Restricted'),
                        2: window.gettext('Virtual'),
                    })[category],
                ),
                remove: id => this.categoryChanged(Number(id)),
            },
            ..._.filter(examinationsFilters, filter => filter.field !== 'examination__books__isnull'),
        ],
    )


    sorts = [
        // {name: 'date', label: window.gettext('Date')},
        // {name: 'title', label: window.gettext('Title')},
        {name: 'id', label: window.gettext('ID'), reversed: true}
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : this.props.store.getIn(['paginator', 'selected']).size === 0
                ? this.props.actions
                : _.concat(
                    this.props.actions,
                    [
                        {
                            label: window.gettext('Supply in store'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna supply these %(count)s items in store?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/store-item/',
                                    body: this.props.store.getIn(
                                        ['paginator', 'selected'],
                                    ).map((comment, id) => ({id, 'supply_in_store': true})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                        {
                            label: window.gettext('Remove from store'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s items from store?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/store-item/',
                                    body: this.props.store.getIn(
                                        ['paginator', 'selected'],
                                    ).map((comment, id) => ({id, 'supply_in_store': false})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                    ],
                )
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    categoryChanged(category, event) {
        if (event)
            event.stopPropagation();
        let categories = this.props.location.query.category || [];
        if (!(categories instanceof Array))
            categories = [categories];
        categories = _.map(categories, category => Number.parseInt(category));
        if (_.includes(categories, category)) {
            _.remove(categories, s => s === category);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, category: categories},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    category: [...categories, category],
                },
            }));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='store-item'
            title={window.gettext('Examination Store Items')}
            listFields={this.listFields}
            selectable={this.props.selectable}
            filters={this.filtersSelector(this.props.store, this.props.location)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.actionsSelector(this.props.store)}
        />;
    }
}

